// extracted by mini-css-extract-plugin
export default {"Wrapper":"OrganizationDetails_Wrapper__k+iuZ","SectionTitle":"OrganizationDetails_SectionTitle__T6Zka"};